// src/pages/Appli/AppliAdmin/ListingClients/ui/AssociationStatusBadge.jsx

import React from "react";

import {
  getAssociationStatusMeta,
} from "../data/associations.data";

export default function AssociationStatusBadge({
  status,
  className = "",
}) {
  const meta = getAssociationStatusMeta(status);

  return (
    <span
      className={[
        "inline-flex items-center gap-1.5",
        "rounded-full px-2.5 py-1",
        "text-xs font-semibold",
        "ring-1 ring-inset",
        meta.tone,
        className,
      ].join(" ")}
    >
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: meta.chartColor }}
      />

      {meta.value}
    </span>
  );
}